import "./ArticleCardGiftPopup.scss";

import React from "react";

import BundleImage from "../BundleImage";
import { FormattedMessage } from "react-intl";
import ArticleStore from "../../../../../../stores/ArticleStore";
import { FetchedArticle, LoadingState } from "shared/src/stores/ArticleStore";
import { connect } from "shared/src/stores/storeConnect";
import { Popover } from "react-bootstrap";
import { BettyVariant } from "shared/src/types/EvaluateArticleNew";

type PropType = {
    bundleId: string;
    article: FetchedArticle | BettyVariant | { state: LoadingState } | null | undefined;
};

class DisconnectedArticleCardGiftPopup extends React.Component<PropType> {
    constructor(props: PropType) {
        super(props);
        ArticleStore.fetchArticleWithBundleId([props.bundleId]);
    }

    componentWillReceiveProps(nextProps: PropType) {
        if (!this.props.article) {
            ArticleStore.fetchArticleWithBundleId([nextProps.bundleId]);
        }
    }

    getBundleInfo() {
        if (!this.props.article || !("bundles" in this.props.article) || !this.props.article.bundles) {
            return null;
        }
        const bundleId = this.props.bundleId.substr(this.props.bundleId.length - 4, 4);
        return this.props.article.bundles[bundleId];
    }

    renderGiftPopupImage(url: string, description?: string) {
        return (
            <div className="mfcss_card-article-2--image">
                <BundleImage
                    onSuccessfulLoad={() => {}}
                    src={{ variant: url }}
                    description={description}
                    breakPointConfigs={[{ upperBreakpoint: 768, imageWidth: 200, imageHeight: 150 }]}
                />
            </div>
        );
    }

    render() {
        const bundle = this.getBundleInfo();
        if (!bundle) {
            return null;
        }
        const description = bundle.description;
        const imageUrl = bundle.imageUrlL;
        return (
            <Popover {...this.props} className="sd-gift-popup" id="giftPopover">
                <div>
                    <p className={"sd-gift-popup-label border-bottom text-center"}>
                        <FormattedMessage id={"EX_FREE_GIFT_LABEL"} />
                    </p>
                    {this.renderGiftPopupImage(imageUrl, description)}
                    <p className={"sd-gift-popup-label"}>{description}</p>
                </div>
            </Popover>
        );
    }
}
export const ArticleCardGiftPopup = connect(
    {
        stores: [
            [
                ArticleStore,
                (s: typeof ArticleStore, props: PropType) => ({
                    article: s.getOneArticleDataWithBundleId(props.bundleId)
                })
            ]
        ]
    },
    DisconnectedArticleCardGiftPopup
);
